import Grid from '@mui/material/Grid';
import React, {useState, useEffect} from 'react';

import CustomDrawer from '../CustomDrawer/CustomDrawer';
import CustomList from '../CustomList/CustomList';
import FilterSelectorMenu from '../FilterMenus/FilterSelectorMenu';

const FilterDrawer = ({
  open,
  onToggleOff,
  filters,
  setFilters,
  selectedFilter,
  showApplyActionButton,
  setSelectedFilter,
  onApplyFilter,
  onClearFilterClick,
  allowDateRangeSelection,
  isLoading,
}) => {
  const [openCustomDateSelection, setOpenCustomDateSelection] = useState(false);

  const [filterValueGridSize, setFilterValueGridSize] = useState({width: 350, height: 1000});

  const addFilter = (filter) => {
    setFilters((prevState) => {
      return prevState.map((ele) => {
        if (ele.id === filter.id) {
          return filter;
        } else {
          return ele;
        }
      });
    });
    setSelectedFilter(filter);
  };

  useEffect(() => {
    const handleResize = () => {
      const grid = document.getElementById('filter-value-grid');
      if (grid) {
        setFilterValueGridSize({
          width: grid.clientWidth,
          height: grid.clientHeight,
        });
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <CustomDrawer
        widthPerc={35}
        title={'Filters'}
        anchor={'right'}
        open={open}
        onToggleOff={onToggleOff}
        showDialogActions={true}
        actionButtons={[
          {
            text: 'Clear All',
            onClick: onClearFilterClick,
            variant: 'text',
            disabled: false,
          },
          {
            text: 'Apply',
            onClick: onApplyFilter,
            className: 'color-secondary',
            variant: 'contained',
            disabled: false,
            hide: !showApplyActionButton,
            isLoading,
          },
        ]}
      >
        <Grid container sx={{height: '100%'}}>
          <Grid
            sx={{
              width: '35%',
              backgroundColor: (theme) => theme.palette.grey[100],
            }}
          >
            <CustomList filters={filters} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
          </Grid>
          <Grid id="filter-value-grid" sx={{width: '65%', maxHeight: '100%', overflowY: 'auto'}}>
            <FilterSelectorMenu
              addFilter={addFilter}
              currentFilter={selectedFilter}
              openCustomDateSelection={openCustomDateSelection}
              setOpenCustomDateSelection={setOpenCustomDateSelection}
              showMenuItemSelectBox={true}
              showSelectedDisabled={false}
              allowDateRangeSelection={allowDateRangeSelection}
              virtualLoadWidth={filterValueGridSize.width}
              virtualLoadHeight={filterValueGridSize.height + 100}
            />
          </Grid>
        </Grid>
      </CustomDrawer>
    </>
  );
};

export default FilterDrawer;
